import React from 'react'

const BenifitContent = () => {
  return (
    <div id='benifitContent'>
        <h1>Discover Your Exclusive Trade Benefits</h1>
        <section>
            
        </section>
    </div>
  )
}

export default BenifitContent